export default "__VITE_ASSET__C$MXHJnV__"